import React, { useCallback } from 'react';

import { NotificationManager, useActivatePromoCode } from '@atlas/core';
import { Button, Input, Label, Loader } from '@atlas/ui';

import { PROMO_CODES_ERRORS } from 'src/common/constants';

const PromoCodesApply = ({ changeCurrentPage, getPromoCodes, paging: { currentPage } }) => {
  const [value, setValue] = React.useState('');
  const [active, setActive] = React.useState(false);
  const { activatePromoCode, error, loading } = useActivatePromoCode();

  const handleButtonClick = useCallback(() => {
    const promoCode = value.trim();

    if (!promoCode) return;

    activatePromoCode(promoCode)
      .then(() => {
        setValue('');

        NotificationManager.notify({
          message: 'promocode_applied',
          status: 'success',
          type: 'notification',
        });

        if (currentPage === 0) {
          getPromoCodes();
        } else {
          changeCurrentPage(0);
        }
      })
      .catch(() => {});
  }, [activatePromoCode, changeCurrentPage, currentPage, getPromoCodes, value]);

  return (
    <div className="promo-codes-apply-block">
      <div className="promo-codes-apply-input">
        <Input
          active={active}
          error={error}
          label="promocode"
          onBlur={() => setActive(false)}
          onChange={e => setValue(e.target.value)}
          onFocus={() => setActive(true)}
          value={value}
        />
        {error && (
          <Label
            className="promo-code-apply-error"
            message={PROMO_CODES_ERRORS[error.message] || PROMO_CODES_ERRORS.DEFAULT}
          />
        )}
      </div>
      <Button disabled={!value} onClick={handleButtonClick} size="big">
        {loading ? <Loader /> : <Label message="apply" />}
      </Button>
    </div>
  );
};

export default PromoCodesApply;
